// frontend/packages/business-console/src/components/primitives/GradientHeroCard.jsx
//
// The one blue->purple gradient hero card. Exactly one hero per screen
// (handoff README section 2: gradient is a thin accent, never a full
// background wash): Payments balance, Pulse money, Analytics revenue,
// AI Visibility score. The gradient is identical in light and dark.
//
// `variant="hero"` is the deep blue->purple (default, for the primary
// KPI). `variant="accent"` is the brighter wordmark gradient.

import React from 'react';
import { Box } from '@mui/material';

import { useTokens } from './useTokens';

export default function GradientHeroCard({
  children,
  variant = 'hero',
  radius = '14px',
  sx,
}) {
  const t = useTokens();
  return (
    <Box
      sx={{
        background: variant === 'accent' ? t.gradient : t.gradientHero,
        color: '#fff',
        borderRadius: radius,
        p: '18px 20px',
        minWidth: 0,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
